import { HttpClient } from '../HttpClient';
/**
 * * Get Attendance Report Company Filter
 */

export const GetCompanyFilter = async () => {
  try {
    const { data } = await HttpClient.get('api/attendancereportfilters/getcompanyfilter');
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
